import _find from 'lodash/find';
import _sortBy from 'lodash/sortBy';
import _groupBy from 'lodash/groupBy';
import _filter from 'lodash/filter';
import moment from 'moment';

import cityService from 'api/city';
import inventoryService from 'api/inventory';
import dateUtils from 'utils/dateUtils';

function Ctrl($scope, $state, $q, $timeout, inventorySearchService, membershipService, metaTagService, utilsService, loggerService,
  modalService, tracking, jsSdkCuratedList, imgix, jsSdkAuth) {

  metaTagService.set({
    title: 'Tablelist Diamond Membership Perks',
    description: 'Find perks in your city. Tablelist Diamond Tickets, Tables and Packages.'
  });

  if (!membershipService.isUserSubscribed()) {
    $state.go('app.membership.landing');

    return;
  }

  $scope.inventory = [];

  $scope.isLoggedIn = function() {
    return jsSdkAuth.isLoggedIn();
  };

  $scope.searchInventoryForm = {
    date: moment()
  };

  $scope.datePickerOptions = {
    startDate: moment(),
    minDate: moment(),
    parentEl: '.calendar-btn',
    locale: {
      format: 'MMM DD, YYYY'
    }
  };

  $scope.$watch('searchInventoryForm.date', () => {
    if (!$scope.pageInit) return;

    $scope.getInventoryByCityId($scope.currentCity.id);
  });

  $scope.getVenueImage = function(venue) {
    if (!venue || !venue.primaryImage) return '';

    return venue.primaryImage.filename;
  };

  $scope.changeCity = function() {
    if ($scope.currentUser) {
      utilsService.setPreferredCity($scope.currentCity.id)
        .then(() => {
          return null;
        });
    }

    $scope.getInventoryByCityId($scope.currentCity.id);
  };

  $scope.getInventoryByCityId = function(cityId) {
    $scope.inventoryLoading = true;

    return $q.resolve(inventoryService.listByCityId(cityId, {
        dateStart: dateUtils.toUTCTimestampWithoutTime($scope.searchInventoryForm.date),
        dateEnd: dateUtils.toUTCTimestampWithoutTime($scope.searchInventoryForm.date),
        membershipLevelMin: 50,
        fields: 'venue(name, images, location, visibility)'
      }))
      .then(result => {
        $scope.inventoryLoading = false;

        $scope.inventory = _filter(result.data, inv => {
          return inv.venue.visibility >= 20;
        });

        const groups = _groupBy($scope.inventory, 'venue._id');

        $scope.inventoryGroupedByVenue = Object.keys(groups).map(key => {
          return {
            inventory: groups[key],
            venue: groups[key][0].venue
          };
        });
      });
  };

  $scope.currentCityImage = function() {
    if (!$scope.currentCity) return '';

    const image = $scope.currentCity && $scope.currentCity.images && $scope.currentCity.images.length ? _find($scope.currentCity.images, {
      primary: true
    }) : {};

    return image.filename;
  };

  $scope.selectInventory = function(inventory) {
    $scope.selectedInventory = inventory;
  };

  $scope.deselectInventory = function() {
    $scope.selectedInventory = null;
  };

  $scope.loading = true;

  $q.resolve(cityService.list())
    .then(result => {
      $scope.cities = _sortBy(result.data, 'name');

      $scope.currentCity = _find($scope.cities, {
        id: utilsService.defaultCityId()
      }) || $scope.cities[0];

      $scope.loading = false;

      $scope.pageInit = true;

      return $scope.getInventoryByCityId($scope.currentCity.id);
    });
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$q',
  '$timeout',
  'inventorySearchService',
  'membershipService',
  'metaTagService',
  'utilsService',
  'loggerService',
  'modalService',
  'trackingService',
  'jsSdk.curatedList',
  'jsSdk.imgix',
  'jsSdk.auth'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/membershipPerks/membershipPerksCtrl.js